import { chakra } from '@chakra-ui/react';
import React from 'react';

import { route } from 'nextjs-routes';

import config from 'configs/app';
import { useColorModeValue } from 'toolkit/chakra/color-mode';
import { Image } from 'toolkit/chakra/image';
// import IconSvg from 'ui/shared/IconSvg';

import { INVERT_FILTER } from './consts';

export type IconName = | 'networks/recordercoin-logo' | 'networks/logo-placeholder';

const IconFallback = () => {
  // const iconName = useColorModeValue(
  //   'networks/recordercoin-logo',
  //   'networks/recordercoin-logo-light',
  // );
  return (
  // <IconSvg
  //   name={ iconName }
  //   w="30px"
  //   h="30px"
  //   color={{ base: 'blue.600', _dark: 'white' }}
  //   aria-label="Network icon placeholder"
  // />

    <Image
      src="/logo/uniieq.png"
      w="30px"
      h="30px"
      alt="Uniieq"
    />

  );
};

type Props = {
  className?: string;
};

const NetworkIcon = ({ className }: Props) => {

  const iconSrc = useColorModeValue(config.UI.navigation.icon.default, config.UI.navigation.icon.dark || config.UI.navigation.icon.default);

  return (
    <chakra.a
      className={ className }
      href={ route({ pathname: '/' }) }
      aria-label="Link to main page"
    >
      <Image
        w="30px"
        h="30px"
        src={ iconSrc }
        alt={ `${ config.chain.name } network icon` }
        fallback={ <IconFallback/> }
        filter={{ _dark: !config.UI.navigation.icon.dark ? INVERT_FILTER : undefined }}
        objectFit="contain"
        objectPosition="left"
      />
    </chakra.a>
  );
};

export default React.memo(chakra(NetworkIcon));
